import AppContainer from "../components/AppContainer";
import styles from "../styles/Home.module.css";

const NotFound = () => (
  <AppContainer>
    <img src="/404.png" className={styles.title404} alt="404 image"></img>

    <p className={styles.notFoundMessage}>
      The page you are looking for does not exist. <br /> Sorry :(
    </p>

    <a href="/" className={styles.notFoundHeadHome}>
      Head home
    </a>
  </AppContainer>
);

export default NotFound;

/*
  import Link from "next/link";

const NotFound = () => (
  <div className="flex min-h-screen items-center justify-center bg-[var(--side-bg-color)]">
    <div className="flex h-screen w-screen max-w-[var(--max-width)] flex-col items-center justify-center bg-[var(--app-bg-color)]">
      <img
        src="/illustrations/404-Error-illustration.svg"
        alt="404 image"
        height="250px"
        width="250px"
        className="object-cover"
      />

      <p className="mt-8 max-w-sm text-center text-xl">
        Oops! We couldn't find that page. <br />
        Let's get you back on track.
      </p>

      <Link href="/" prefetch={true}>
        <a className="mt-8 rounded-lg bg-primary px-6 py-4 text-xl">Head home</a>
      </Link>

      <footer className="fixed bottom-10 left-1/2 -translate-x-1/2 transform text-center">
        <small className="opacity-70">
          Illustrations by{" "}
          <a href="https://storyset.com/web" target="_blank" rel="noopener noreferrer">
            Storyset
          </a>
        </small>
      </footer>
    </div>
  </div>
);

export default NotFound;

*/
